/**
 * Represents a collection of common text used in the application.
 */
export const Vocabulary: any = {
  /** COMMON TEXT */
  webPage: "Pagina web",
  companies: "Companii",
  predefined: "Predefinite",
  login: "Conectare",
  oblioIntegration: "Integrări Oblio",
  fgoIntegration: "Integrări Fgo",
  fgoPass: "Pass Fgo",
  fgoApiUrl: "URL API Fgo",
  fgoIsActive: "Activează integrarea Fgo",
  oblioApiUrl: "URL API Oblio",
  oblioClientId: "Client ID Oblio",
  oblioClientSecret: "Client Secret Oblio",
  oblioIsActive: "Activează integrarea Oblio",
  invalidUrl: "URL invalid",
  disableOblioToActivateFgo:
    "Dezactivează integrarea Oblio pentru a activa Fgo",
  disableFgoToActivateOblio:
    "Dezactivează integrarea Fgo pentru a activa Oblio",
  loginValidationError: "Eroare la validarea datelor!",
  requiredField: "Acest câmp este obliugatoriu.",
  emailValidation: "Introduceți  o adresă valida.",
  pageNotFound: "Pagina nu a fost găsită!",
  search: "Căutare",
  siteName: "Cafe-Mag",
  delay: "Întârziere",
  finishOrderText: "Comanda se va finaliza, iar stocurile vor fi modificate.",
  logout: "Deconectare",
  documentation: "Documentație",
  defaultManagement: "Gestiune implicită",
  subtotal: "Subtotal",
  confirm: "Confirmare",
  orderOfferWhatsappTemplate: "Șablon WhatsApp pentru comandă/ofertă",
  whatsAppFooterNoteObservation: "",
  pages: "Pagini",
  image: "Imagine",
  newMasculine: "Nou",
  userManual: "Manual de utilizare",
  notifications: "Notificări",
  noNotifications: "Nu există notificări",
  myAccount: "Contul meu",
  legalPerson: "Persoană juridică",
  physicalPerson: "Persoană fizică",
  shouldClientReceiveEmail: "Clientul ar trebui să fie contactat prin email?",
  syncProducts: "Sincronizare produse",
  users: "Utilizatori",
  user: "Utilizator",
  CNP: "CNP",
  userSettings: "Setări utilizator",
  noConversationsAvailable: "Nu sunt conversații disponibile",
  addNewConversation: "Adaugă conversație nouă",
  conversations: "Conversații WhatsApp",
  newConversation: "Conversație nouă",
  selectAllProductsForInvoice: "Selectează toate produsele pentru facturare",
  departments: "Departamente",
  options: "Opțiuni",
  WARNING: "Avertisment",
  phoneNumbers: "Numere de telefon",
  availablePhoneNumber: "Număr de telefon disponibil",
  whatsAppEditTemplateLimit:
    " Șabloanele aprobate pot fi editate de până la 10 ori într-o fereastră de 30 de zile sau o dată într-o fereastră de 24 de ore. Dacă ați efectuat deja această acțiune, vă rugăm să reveniți mai târziu.",
  whatsAppTemplateEditingWarning:
    "Doar șabloanele cu statusul APROBAT, RESPINS sau ÎN APROBARE pot fi editate. Puteți edita doar categoria sau componentele unui șablon. Nu puteți edita categoria unui șablon aprobat. Șabloanele aprobate pot fi editate de până la 10 ori într-o fereastră de 30 de zile sau o dată într-o fereastră de 24 de ore. Șabloanele respinse sau în pauză pot fi editate de un număr nelimitat de ori. După editarea unui șablon aprobat sau în aprobare, acesta va fi aprobat automat, cu excepția cazului în care nu trece de revizuirea șablonului.",
  countryCode: "Cod țară",
  phoneNumbersDisplayName: "Numele afișat pentru numărul de telefon",
  lastName: "Nume",
  product: "Produs",
  entityName: "Nume entitate",
  collected: "Încasată",
  collect: "Încasează",
  notCollected: "Neîncasată",
  canceled: "Anulată",
  unread: "Necitit",
  completed: "Finalizat",
  in_progress: "În curs de ofertare",
  read: "Citit",
  corrected: "Stornată",
  invoiced: "Facturat",
  previewDocument: "Previzualizare document",
  previewVideo: "Previzualizare video",
  addPhoneNumber: "Adaugă număr de telefon",
  firstName: "Prenume",
  preview: "Previzualizare",
  continue: "Continuă",
  code: "Cod",
  property: "Proprietate",
  create: "Crează",
  upload: "Încarcă",
  learnMore: "Află mai mult",
  pin: "PIN",
  select: "Selectați",
  back: "Înapoi",
  location: "Locație",
  industry: "Industrie",
  companyName: "Nume companie",
  phoneNumbersDisplayNameHelperText:
    "Numele dvs. afișat trebuie să se potrivească cu numele companiei dvs. și să respecte regulile privind numele afișat WhatsApp Business. ",
  twoStepVerificationPinHelperText:
    "Introduceți un cod pentru autentificarea în doi pași atunci când vă conectați utilizând numărul de telefon WhatsApp Business",
  lastStep: "Ultimul pas",
  registerPhoneNumber: "Înregistrare număr de telefon",
  register: "Înregistrare",
  verifyPhoneNumberRegistrationCode:
    "Introducere cod de verificare primit prin SMS",
  setPinForTwoStepVerification: "Setare PIN pentru autentificare în doi pași",
  buttonText: "Text buton",
  orderNr: "Număr comandă",
  thankYouForYourOrder: "Mulțumim! Comanda a fost plasată.",
  ANPC: "ANPC",
  contact: "Contact",
  addNewTemplate: "Adaugă șablon nou",
  cookiePolicy: "Politica Cookies",
  old: "Veche",
  goods: "Marfa",
  password: "Parolă",
  view: "Vizualizează",
  cancelAction: "Anulează",
  billingAction: "Facturează",
  previous: "Anterior",
  next: "Următor",
  crtNo: "Nr. crt.",
  invoice: "Factură",
  notice: "Aviz",
  issuingInvoice: "Emitere factură",
  issuingNotice: "Emitere aviz",
  email: "Email",
  addImage: "Adaugă imagine",
  columns: "Coloane",
  phoneNumber: "Număr de telefon",
  roles: "Roluri",
  role: "Rol",
  roleName: "Nume rol",
  rolePriority: "Prioritate rol",
  allowedRoutes: "Pagini accesibile",
  createRole: "Creează rol",
  editRole: "Editează rol",
  deleteRole: "Șterge rol",
  selectAccessiblePages: "Selectează paginile accesibile",
  systemRole: "Rol sistem",
  customRole: "Rol personalizat",
  cannotModifySystemRole: "Nu se pot modifica rolurile sistem",
  cannotDeleteSystemRole: "Nu se pot șterge rolurile sistem",
  lei: "Lei",
  department: "Departament",
  edit: "Editează",
  delete: "Șterge",
  description: "Descriere",
  noResultsFound: "Nu a fost găsit nici un rezultat...",
  nextPage: "Pagina următoare",
  previousPage: "Pagina anterioară",
  rowsPerPage: "Rânduri pe pagină",
  of: "din",
  downloadCSV: "Descarcă CSV",
  print: "Printează",
  uploadImageOnEmailTemplateMessage:
    "Asigurați-vă că ați plasat cursorul unde doriți să plasați imaginea!",
  message: "Mesaj",
  messageHistory: "Istoric Mesaj",
  rowsDeleted: "rânduri șterse",
  rowsSelected: "rânduri selectate",
  usersList: "Listă utilizatori",
  departmentsList: "Listă departamente",
  tasksList: "Listă task-uri",
  projectsList: "Listă proiecte",
  reportsList: "Listă rapoarte",
  deleteFilters: "Șterge filtre",
  tasks: "Task-uri",
  add: "Adaugă",
  import: "Importă",
  project: "Proiect",
  assignedUser: "Responsabil",
  name: "Nume",
  ok: "OK",
  addSubtask: "Adaugă subtask",
  subtask: "Subtask",
  subtasks: "Subtask-uri",
  noUserAssigned: "Nu există utilizator asignat",
  sendMessageTemplateToUser: "Trimite șablon",
  sending: "Se trimite...",
  messageType: "Tip mesaj",
  selectAConversation: "Selectează o conversație.",
  canOnlySendTemplateToClient:
    "Șabloanele pot fi trimise doar clienților existenți.",
  youHaveUnreadMessages: "Aveți mesaje necitite.",
  unsavedChangesTitleModal: "Modificări nesalvate",
  unsavedChangesTextModal:
    "Dacă părăsiți pagina, modificările nesalvate vor fi pierdute. Sunteți sigur că doriți să părăsiți pagina?",
  departmentHead: "Șef departament",
  projectManager: "Manager proiect",
  status: "Status",
  flexibleTask: "Task flexibil",
  repeatsOn: "Repetă",
  skipWeekend: "Sari peste weekend",
  flexibleTaskObservations:
    "Permite posibilitatea de modificare a periodicitații",
  progress: "Progres",
  addNewUser: "Adaugă utilizator nou",
  editUser: "Editează utilizator",
  addNewDepartment: "Adaugă departament nou",
  save: "Salvare",
  update: "Actualizare",
  approve: "Aprobare",
  saveContact: "Salvează contact",
  cancel: "Anulare",
  addFiles: "Adaugă fișiere",
  attacheFiles: "Fișiere atașate",
  finish: "Finalizare",
  generate: "Generează",
  finished: "Finalizat",
  unfinished: "Nefinalizat",
  userName: "Nume utilizator",
  taskName: "Nume task",
  active: "Active",
  addConversation: "Adaugă conversație",
  archived: "Arhivat",
  cif: "CIF",
  messages: "Mesagerie WhatsApp",
  clientMessages: "Mesaje",
  createClient: "Creează client",
  clientAlreadyCreated: "Client deja creat",
  baseInfo: "Informații generale",
  dynamicInfo: "Informații dinamice",
  attachments: "Atașamente",
  issueDate: "Data emiterii",
  dueDate: "Data scadenței",
  otherInfos: "Alte informații",
  issuerName: "Întocmit de",
  issuerId: "CNP",
  deputyIdentityCard: "Carte identitate delegat",
  selesAgent: "Agent vânzări",
  filters: "Filtre",
  invoiceWarning:
    "Pentru a evita erori și neînțelegeri în procesul de facturare, vă rugăm să verificați cu atenție informațiile despre client înainte de a emite o factură. Asigurați-vă că toate datele sunt corecte și actualizate pentru a asigura un proces de facturare fără probleme. ",
  deputyName: "Delegat",
  fancyName: "Denumire",
  startDate: "Data start",
  nextContactDate: "Data următoarei contactări",
  nextTransportDate: "Data următoarei livrări",
  endDate: "Data final",
  fullName: "Nume complet",
  position: "Funcție",
  dragAndDrop:
    "Trageți și plasați orice fișier aici sau răsfoiți de pe dispozitiv",
  error: "Eroare!",
  notFound: "Nu a fost găsit.",
  dashboard: "Dashboard",
  newTask: "Task nou",
  url: "URL",
  supportTickets: "Tichete suport",
  marketing: "Marketing",
  sales: "Vânzări",
  profilePicture: "Poza de profil",
  addCustomField: "Adaugă câmp personalizat",
  customField: "Câmp personalizat",
  custom: "Personalizat",
  specificAction: "Acțiune specifică",
  quickReply: "Răspuns rapid",
  visitSite: "Vizitează site",
  callPhoneNumber: "Sună numărul de telefon",
  value: "Valoare",
  priority: "Prioritate",
  periodicity: "Periodicitate de contactare",
  periodic: "Periodic",
  type: "Tip",
  home: "Acasă",
  daily: "Zilnic",
  weekly: "Săptămânal",
  monthly: "Lunar",
  yearly: "Anual",
  choosePeriodicity: "Alege periodicitate",
  biannual: "Semestrial",
  quarterly: "Trimestrial",
  unique: "Unic",
  highPriority: "Înaltă",
  mediumPriority: "Medie",
  lowPriority: "Scăzută",
  chooseUser: "Alege utilizator",
  chooseProject: "Alege proiect",
  choosePriority: "Alege prioritate",
  chooseDepartment: "Alege departament",
  chooseStatus: "Alege status",
  clients: "Clienti",
  client: "Client",
  missingClient: "Client lipsește nu pot salva documentul",
  clientAddress: "Adresa client",
  invoiceAddress: "Adresa de facturare",
  deliveryAddress: "Adresa de livrare",
  clientDetails: "Detalii client",
  orderDetails: "Detalii comandă",
  phoneNumberDetails: "Detalii număr de telefon",
  order: "Comanda",
  Verified: "Verificat",
  notVerified: "Neverificat",
  postcode: "Cod poștal",
  creationDate: "Data creării",
  lastModified: "Ultima salvare",
  orderProducts: "Produse comandă",
  ordersStatuses: "Status comenzi",
  templates: "Șabloane",

  checkPhoneNumber: "Verificare număr de telefon",
  pagination: {
    next: "Urmator",
    previous: "Anterior",
    rowsPerPage: "Pe pagina:",
    displayRows: "din",
  },
  noData: "Nu exista date!",
  orders: "Comenzi Marfă",
  reset: "Resetează",
  statusesOrder: "Ordinea statusurilor",
  reports: "Rapoarte",
  confirmDeleteTitle: "Confirmare ștergere",
  confirmDeleteMessage: "Ești sigur că vrei să ștergi această înregistrare?",

  confirmDuplicateMessage:
    "Ești sigur că vrei să duplici această înregistrare?",
  no: "Nu",
  yes: "Da",
  editModalTitle: "Editează",
  username: "Nume utilizator",
  saveSuccess: "Datele au fost salvate cu succes!",
  saveError: "Eroare la salvarea datelor!",
  editOrderStatus: "Editează status comandă",
  addOrderStatus: "Adaugă status comandă",
  getError: "Eroare la preluarea datelor!",
  deleteSuccess: "Datele au fost șterse cu succes!",
  deleteError: "Eroare la ștergerea datelor!",
  newOrderStatus: "Status comandă nou",
  orderStatus: "Status comandă",
  phone: "Telefon",
  contactPerson: "Persoană de contact",
  address: "Adresă",
  usefulInfo: "Informații utile",
  observations: "Observații",
  noMoreMessages: "Nu mai sunt mesaje",
  sendMessagesInfo:
    "Pentru a comunica eficient prin WhatsApp, este necesar să trimitem mai întâi un template de mesaj aprobat de WhatsApp. Acest mesaj introductiv trebuie să ofere utilizatorului toate detaliile necesare și să solicite un răspuns. După ce utilizatorul răspunde la acest mesaj, putem continua conversația fără restricții, conform regulilor WhatsApp, asigurând astfel o comunicare fluentă și eficientă.",
  fiscalCode: "Cod fiscal",
  tradeRegisterNo: "Nr. Registru Comerț",
  registered: "Înregistrat",
  notRegistered: "Neînregistrat",
  whatsAppRegisterPhoneNumberHelperText:
    "Ultimul pas înainte de a putea comunica prin WhatsApp Business este să înregistrați numărul de telefon. Dacă numărul de telefon verificat are deja activată verificarea în doi pași, introduceți codul PIN de 6 cifre. Dacă numărul de telefon verificat nu are activată verificarea în doi pași, setați un cod PIN de 6 cifre. ",
  details: "Detalii",
  week: "Săptămâna",
  day: "Ziua",
  city: "Oraș",
  county: "Județ",
  tools: "Instrumente",
  country: "Țară",
  takenBy: "Preluat de",
  addressDetails: "Detalii adresă",
  category: "Categorie",
  categories: "Categorii",
  tags: "Etichete",
  addVariable: "Adaugă variabilă",
  selectATemplateBeforeSendingAnEmail:
    "Selectați un șablon înainte de a trimite un email",
  variable: "Variabilă",
  samplesForBodyContent: "Exemple pentru conținutul variabilelor",
  addButton: "Adaugă buton",
  whatsAppHeaderNoteObservation:
    "Adăugați un titlu sau alegeți ce tip de conținut media veți folosi pentru acest antet.",
  messageswhatsAppFooterNoteObservation:
    "Dacă adăugați mai mult de 3 butoane, acestea vor apărea într-o listă. Numărul maxim de butoane permise este 10.",
  enterWhatsAppMessageFooterText:
    "Adăugați un scurt text în subsolul șablonului de mesaj.",
  enterWhatsAppMessageBodyText:
    "Introduceți textul corpului mesajului WhatsApp în limba selectată.",
  whatsAppFooterButtonsHelperText:
    "Creați butoane care le permit clienților să răspundă la mesajul dumneavoastră sau să execute o acțiune specifică.",
  bank: "Banca",
  iban: "IBAN",
  noDays: "Nr. zile",
  optional: "Opțional",
  required: "Obligatoriu",
  contactPersonName: "Nume persoană contact",
  contactPersonPhoneNumber: "Număr de telefon persoană contact",
  contactPersonEmail: "Email persoană contact",
  categoryName: "Denumire categorie",
  periodicityName: "Nume periodicitate",
  color: "Culoare",
  chooseTemplate: "Alege șablon",
  chooseType: "Alege tip",
  emailContent: "Conținut email",
  exampleContent: "Exemplu conținut",
  price: "Preț",
  products: "Produse",
  actionSummary: "Sumar acțiune",
  emailContentError: "Conținutul email-ului este obligatoriu",
  pretOnSite: "Preț pe site",
  oblioPrice: "Preț Oblio",
  wordpressSync: "Sincronizare Wordpress",
  billing: "Facturare",
  diferences: "Diferențe",
  SUCCESS: "Succes",
  ERROR: "Eroare",
  INFO: "Informație",
  action: "Acțiune",
  info: "Informație",
  noIdentifier: "Fără identificator",
  identifier: "Identificator",
  initialsValues: "Valori inițiale",
  modifiedValues: "Valori după modificare",
  "email-templates": "Șabloane email",
  "order-statuses": "Status comenzi",
  "transport-options": "Opțiuni transport",
  "tax-classes": "Clase TVA",
  "client-categories": "Categorii clienți",
  whatsapps: "Configurare WhatsApp",
  company: "Companie",
  ignoreOblioIdsList: "Lista de ID-uri Oblio ignorate (separate prin virgulă)",
  nameContactPerson: "Nume persoană contact",
  orderSummary: "Sumar comandă:",
  contactPhoneNumber: "Număr de contact",
  date: "Data",
  dateWithDiacritics: "Dată",
  total: "Total",
  logs: "Loguri",
  confirmSaveOrUpdateOrder: "Confirmați salvarea sau actualizarea comenzii?",
  orderSettings: "Setări comandă",
  startOrderNumber: "Nr. comandă start",
  currentOrderNumber: "Nr. comandă curent",
  paymentMethods: "Metode de plată",
  emailTemplates: "Șabloane email",
  emailPreview: "Previzualizare email",
  addClient: "Adaugă client nou",
  associateConversationWithClient: "Asociază conversația",
  associateExistingClient: "Asociază client existent",
  addNewClientOrAssociateExisting:
    "Momentan, conversația nu este asociată cu niciun client din aplicație. Dorești să adaugi un client nou, care va fi asociat automat cu această conversație, sau să asociezi unul existent?",
  template: "Șablon",
  subject: "Subiect",
  from: "De la",
  method: "Metodă",
  phoneNumberFormat: "(Format acceptat +40XXXXXXXXX)",
  nrOfAcceptedButtons: "Nr. butoane permise: ",
  whatsappIntegration: "Integrare WhatsApp",
  clientType: "Tip client",
  to: "Către",
  emailTemplate: "Șablon email",
  editor: "Editor",
  emailTemplateName: "Nume șablon email",
  associateClientWithConversation: "Asociază client cu conversație",
  cc: "CC",
  header: "Antet",
  body: "Corp",
  footer: "Subsol",
  buttons: "Butoane",
  productDescription: "Descriere produs",
  loginWithFacebook: "Conectare cu Facebook",
  dimensions: "Dimensiuni",
  length: "Lungime",
  templateName: "Nume șablon",
  templateLanguage: "Limba șablon",
  width: "Lățime",
  remarks: "Observații",
  enterTextInSelectedLanguage: "Introduceți text în limba selectată",
  whatsAppMessagesTemplates: "Șabloane mesaje WhatsApp",
  whatsAppTemplate: "Șablon WhatsApp",
  height: "Înălțime",
  start: "Start",
  end: "Sfârșit",
  days: "Zile",
  lateTask: "Task întârziat",
  finishDate: "Data finalizării",
  productLink: "Link produs",
  whatsAppTemplateBodyContentForHelperText:
    "Pentru a ne ajuta să revizuim șablonul dvs. de mesaj, vă rugăm să adăugați un exemplu pentru fiecare variabilă din corpul dvs. de text. Nu utilizați informații reale despre clienți",
  enterContentFor: "Introduceți conținut pentru",
  enterEmailAddressesSeparatedByComma:
    "Introduceți adresele de e-mail separate prin virgulă",
  addDynamicData: "Adaugă date dinamice",
  additionalData: "Date suplimentare",
  emailTemplateAttachedToOrderStatus: "Atașează la statusul comenzii",
  productName: "Nume Produs",
  unitMeasure: "Unitate de masură",
  quantity: "Cantitate",
  unitPrice: "Preț unitar fără tva",
  cotaTVA: "Cota TVA",
  tva: "TVA",
  duplicate: "Duplică",
  youNeedToSelectAtLeastOneProductToGenerateInvoice:
    "Trebuie să selectați cel puțin un produs pentru a genera o factură",
  youNeedToSelectAtLeastOneProductToGenerateNotice:
    "Trebuie să selectați cel puțin un produs pentru a genera un aviz",
  nr: "Nr.",
  discount: "Discount",
  totalDiscount: "Total discount",
  totalDiscountWithouTVA: "Total discount fără TVA",
  totalWithoutTVA: "Total fără TVA",
  otherCosts: "Alte costuri",
  addProducts: "Adaugă produs",
  collectDocType: "Tip document încasare",
  subTotal: "Sub-total",
  valueWithoutTVA: "Valoare fără TVA",
  priveWithTVA: "Preț unitar cu TVA",
  priceWithoutTVA: "Preț fără TVA",
  shippingInfo: "Informații transport",
  sameAsBilling: "Adresa din datele de facturare",
  newShipping: "Adresa de livrare noua",
  cash: "Numerar la livrare",
  delivery: "Livrare",
  backTransfer: "Transfer bancar",
  orderHasntBeenGenerated: "Comanda nu a fost generata",
  card: "Card online",
  vatRate: "Cota TVA",
  subtotalWithTVA: "Subtotal cu TVA",
  subtotal_tax: "Valoare",
  clientContactedOverEmail: "Contactat prin email:",
  clientCalled: "Contactat telefonic:",
  clientMessaged: "Contactat prin mesaj:",
  takeCustomer: "Preia client",
  totalWithTVA: "Total cu TVA",
  totalTVAIncluded: "Total TVA inclus",
  showTVA: "Afișeaza TVA",
  service: "Service",
  custodie: "Custodie",
  never: "Niciodată",
  courierShipping: "Transport curier",
  stock: "Stoc",
  newOrder: "Comandă nouă",
  close: "Închide",
  noTodaysClients: "Clienți de contactat astăzi",
  clientsToContact: "Clienți de contactat",
  clientsContacted: "Clienți  contactati",
  availableClients: "Clienți zilnici disponibili",
  takenClients: "Clienți zilnici preluati",
  delayedClients: "Clienți disponibili (întârziați)",
  new: "Nouă",
  cifIsRequired: "CIF-ul este obligatoriu",
  clientNameIsRequired: "Numele clientului este obligatoriu",
  seriesNameIsRequired: "Numele seriei este obligatoriu",
  phoneNumberIsRequired: "Numărul de telefon este obligatoriu",
  productNameIsRequired: "Numele produsului este obligatoriu",
  emailIsRequired: "Email-ul este obligatoriu",
  productPriceIsRequired: "Prețul produsului este obligatoriu",
  productQuantityIsRequired: "Cantitatea produsului este obligatorie",
  issuerNameIsRequired: "Numele emitentului este obligatoriu",
  issuerIdIsRequired: "CNP-ul emitentului este obligatoriu",
  mentions: "Mentiuni",
  noticeNumber: "Nr. aviz însoțire",
  defaultInvoiceMentions:
    "Factura valabila fără semnatura si ătampila cf. art. V, ALIN(2) DIN ORD. NR. 17/2015 SI ART. 319 ALIN.(29) DIN LEGEA NR. 227/2015 PRIVIND CODUL FISCAL .Cumparatorul isi exprima acordul privind prelucrarea datelor cu caracter personal, comunicate, date ce vor fi utilizate in scopul intocmirii documentelor comerciale de facturare, incasare, expediere si ofertarii comerciale. Orice modificare de preț va fi afisata pe site-ul www.ECOPACKBUSINESS.ro",
  invoicesInfo: "Informații facturare",
  discountValue: "Valoare discount",
  shortDescription: "Descriere scurta",
  unitTVA: "Valoare unitara TVA",
  confirmDelete: "Confirma stergerea",
  settings: "Setari",
  managements: "Gestiuni",
  management: "Gestiune",
  otherSettings: "Alte setari",
  others: "Altele",
  saveWhatsAppSettings: "Salvează setările WhatsApp",
  shippingSettings: "Setări transport",
  whatsAppBusinessAccountId: "Id cont WhatsApp Business",
  whatsAppBusinessAccountName: "Nume cont  WhatsApp Business",
  whatsAppBusinessPhoneNumberId: "Id număr de telefon WhatsApp Business",
  whatsAppBusinessVerifiedName: "Nume WhatsApp Business",
  whatsAppBusinessAccountDataUpdateMessage:
    "Sunteți sigur că doriți să actualizați datele contului WhatsApp Business?",
  oblio: "Oblio",
  conversationOptions: "Opțiuni conversație",
  LOCAL: "Local",
  WORDPRESS: "WordPress",
  OBLIO: "Oblio",
  META: "META",
  whatsApp: "WhatsApp",
  wordPressSettings: "Integrări WordPress",
  wordPressApiUrl: "URL API WordPress",
  wordPressApiKey: "Cheie API (Consumer Key)",
  wordPressApiSecret: "Secret API (Consumer Secret)",
  wordPressIsActive: "Activat",
  wordPressSyncFrequency: "Frecvența sincronizării",
  wordPressSyncManual: "Manual",
  wordPressSyncHourly: "Orar",
  wordPressSyncDaily: "Zilnic",
  wordPressSyncWeekly: "Săptămânal",
  integrations: "Integrări",
  contactDate: "Data contactării",
  shipping: "Transport",
  clientCategory: "Categorie client",
  clientNotesHistory: "Istoric note client",
  welcomeBack: "Bine ai revenit,",
  sendMessage: "Trimite mesaj",
  sendEmail: "Trimite email",
  createOrder: "Creează comandă",
  creating: "Se creează...",
  messageNotLinkedToClient:
    "Mesajul nu este asociat unui client. Asociați mesajul unui client pentru a putea crea o comandă.",
  summary: "Sumar",
  visibleToClient: "Vizibil clientului",
  finishContact: "Finalizează contact",
  contactedOnPhone: "Telefonic",
  clientCategories: "Categorii clienti",
  wasClientCalledOverPhone: "Clientul a fost contactat telefonic?",
  contacted: "Contactat",
  noOrder: "Fără comandă",
  notContacted: "Necontactat",
  shouldSendEmailToAllClients:
    "Activează/dezactivează trimiterea automată de emailuri pentru toți clienții.",
  addNotes: "Adaugă note",
  notes: "Notițe",
  addNewNote: "Adaugă notă nouă",
  saveNote: "Salvează nota",
  savedNotes: "Notițe salvate",
  noSavedNotes: "Nu există notițe salvate încă",
  noteDeleted: "Nota a fost ștearsă",
  noteSaved: "Nota a fost salvată cu succes",
  enterNoteText: "Vă rugăm să introduceți un text pentru notă",
  writeNoteHere: "Scrieți nota dvs. aici...",
  deleteNoteError: "Eroare la ștergerea notei",
  saveNoteError: "Eroare la salvarea notei",
  text: "Text",
  reply: "Răspunde",
  templatePreview: "Previzualizare șablon",
  note: "Nota",
  doYouWantToTakeOverThisClient: "Doriți să preluați acest client?",
  transportName: "Nume transport",
  transportValue: "Valoare transport",
  isDefaultTransport: "Transport implicit",
  addMethod: "Adaugă metodă",
  paymentMethod: "Metodă de plată",
  loadMoreMessages: "Incarca mai multe mesaje",
  noPreviewAvailable: "Previzualizare indisponibilă",
  noMessagesYet:
    "Nu există mesaje.\n Pentru a iniția o conversație, trimiteți un sablon. \n\n Dacă clientul va raspunde în 24 de ore veți putea trimite mesaje nelimitate.",
  noMessages: "Nu există mesaje",
  romania: "România",
  send: "Trimite",
  document: "Document",
  addCaption: "Adaugă descriere",
  missingFile: "Fișier lipsă",
  chooseColor: "Alege culoare",
  orderConfirmMessage: "Vă mulțumim pentru comanda dumneavoastră!",
  chooseNextContactDate: "Alege data urmatoarei contactări:",
  loading: "Se încarca...",
  noMoreItems: "Nu mai sunt elemente!",
  shippingCost: "Cost transport (TVA inclus)",
  currency: "LEI",
  unsavedMessage: "Ai modificari nesalvate!",
  clientConversation: "Conversatie client",
  database: "Baza de date",
  transportMethods: "Metode transport",
  confirmMessage: "Parolele nu coincid!",
  phoneValidation: "Numarul de telefon este invalid",
  finishOrder: "Finalizare comanda",
  clientNote: "Nota adăugată de client",
  optionalOrderNote: "Note comandă (opțional)",
  invalidEmail: "Email invalid",
  missingDevice: "Aparatul defect este obligatoriu",
  deviceCodeMissing: "Seria echipamentului este obligatorie",
  deviceDescriptionMissing: "Descrierea echipamentului este obligatorie",
  contacts: "Contacte",
  threshold: "Valoare de prag (limită)",
  rule: "Regulă",
  agent: "Agent",
  sendNotificationsTo: "Trimite notificări către",
  imagePreview: "Previzualizare imagine",
  contactDeletionThreshold:
    "Numărul de zile după care contactele vechi sunt șterse automat",
  data: "Data",
  shouldRenderOldContactsOnDashboard: "Afișează contactele vechi pe Dashboard.",
  orderMessage:
    "Pentru comenzile ce depasesc 5KG se taxeaza în plus 1 LEU / KG.",
  pressTocChangeStatus: "Apasă pentru a adaugă/schimbă statusul comenzii",
  invoiceDetails: "Detalii de facturare",
  anotherAddress: "Livrezi la o altă adresă?",
  yourOrder: "Comanda ta",
  addNewSubtask: "Adaugă subtask nou",
  imageAlternativeText: "Text alternativ imagine",
  confirmPassword: "Confirmare parola",
  deleteImages: "Șterge imagini",
  outOfStock: "Stoc epuizat",
  assignedBy: "Alocate de",
  editSubtask: "Editează subtask",
  attachedFiles: "Fișiere atașate",
  emptyFields: "Golește câmpurile",
  inStock: "În stoc",
  duplicateTask: "Duplică task",
  task: "Task",
  alerts: "Alerte",
  alert: "Alertă",
  onBackOrder: "Pe comandă",
  customFilter: "Filtru personalizat",
  table: "Tabel",
  noStockInfo: "Fără informații despre stoc",
  endOrder: "Plasează comanda",
  footerText:
    "Avem la comercializare o gama variata de pungi de hartie, atat albita, cat si natur, dar si sacose de hartie cu maner flat sau sfoara.",
  copyright: "© Cafe-Mag Business 2023",
  imageUploadErrorMessage:
    "Trebuie să incărcați o imagine și să oferiți o alternativă de text pentru aceasta!",
  addNewWorkingPoint: "Adaugă punct de lucru nou",
  locations: "Puncte de lucru",
  workingPoint: "Punct de lucru",
  isWorkingPoint: "Este punct de lucru?",
  office: "Sediu social",
  entityType: "Tip entitate",
  discountAmmount: "Reducere totala",
  isPositive: "Este pozitiv",

  /**FROMS */
  serviceFormRequest: "Formular Solicitare Service",
  formDescription:
    "Completarea acestui formular cât mai precis, va ajută la scurtarea timpului de diagnosticare, rapiditatea intervenției și redarea funcționalității echipamentului în cel mai scurt timp.",
  ownerName: "Nume și prenume proprietar/ reprezentant",
  descriptionForOwner:
    "Numele persoanei care deține echipamentul sau reprezintă firma în relație cu noi și asistența defecțiunilor sau programează revizia.",
  phoneNmberDescription:
    "Acest număr de telefon se va folosi în corespondență cu service/ comercial.",
  emailAddress: "Adresa de e-mail ",
  emailAddressDescription:
    " Aceasta adresa va fi cea de corespondență cu service/comercial",
  companyOrPerson: "Firma sau persoana fizică",
  deviceLocation: "Adresa unde se află echipamentul",
  deviceLocationDescription:
    "Adresa unde se află echipamentul si poate fi ridicat de curier",
  brokenDevice: "Echipamentul defect",
  deviceDescription: "Producător/Brand/Model",
  deviceCode: "Serie echipament",
  deviceCodeDescription:
    "Vă rugăm introduceți seria echipamentului. Aceasta se poate afla pe o etichetă sau pe o plăcuță, în partea de jos a echipamentului.",
  deviceBrokenUnit: "Defecțiune sesizată",
  deviceBrokenUnitDescription:
    "Descrieți cât mai clar defectul sesizat, ce se întâmplă atunci când apare disfuncționalitatea.",
  formAttachments: "Fișiere atasate, Foto/Video",
  formAttachmentsDescription:
    "Pentru exemplificare, va rugăm să încărcați fotografii în care să arătați problema descrisă mai sus.",
  chooseFileToUpload: "Alege fisier pentru incarcare",
  dragAndDropAlternative: "sau trage fișierul aici",
  sendForm: "Trimite formular",
  filesSelected: "fisier(e) selectate",
  estimatedPrice:
    "Costul estimativ al reparației va fi comunicat ulterior verificării tehnice efectuate în service.",
  deliveryMessagePart1:
    "Costul ridicării produsului și al transportului către service este acoperit integral de către Cafe-Mag.",
  deliveryMessagePart2:
    "În cazul în care clientul decide să refuze reparația după constatarea efectuată în service,",
  deliveryMessagePart3:
    "costul transportului de retur către client va fi suportat de acesta.",
  companyOrPersonEntity: "Alegeți dacă sunteți companie sau persoană fizică",
  isLegal: "Persoană juridică",
  isNotLegal: "Persoană fizică",
  isLegalEntity: "DA (Persoană juridică)",
  isNotLegalEntity: "NU (Persoană fizică)",
  CUI: "CUI",
  CUIPlaceholder: "Introduceti CUI pentru companie",
  successServiceModal: "Formularul a fost trimis cu succes!",
  yourMessageHasBeenSent: "Mesajul dumneavoastră a fost trimis.",
  weWillContactYouSoon:
    "Un reprezentat Cafe-Mag vă va contacta în cel mai scurt timp posibil.",
  fillAllFields: "Vă rugăm să completați toate câmpurile obligatorii!",
  errorSubmittingTheForm:
    "Eroare la trimiterea formularului. Vă rugăm să încercați din nou.",
  orderPlacementInProgress: "Plasarea comenzii este în curs de desfășurare...",
  errorCreatingErpOrder: "Eroare la crearea comenzii în ERP.",
  /**AUDIT ACTIONS */

  CREATE: "Adăugare",
  UPDATE: "Actualizare",
  DELETE: "Ștergere",
  SOFT_DELETE: "Inactivare",
  IMPORT: "Import",
  DUPLICATE: "Duplicare",

  /**ERRORS */

  systemError: "Eroare de sistem. Contactează administratorul!",
  getDataError: "Eroare la preluarea datelor!",
  deleteDataError: "Eroare la ștergerea datelor!",
  importDataError: "Eroare la importul datelor!",
  createDataError: "Eroare la adăugarea datelor!",
  updateDataError: "Eroare la actualizarea datelor!",
  deleteDataSuccess: "Datele au fost șterse cu succes!",
  importDataSuccess: "Datele au fost importate cu succes!",
  createDataSuccess: "Datele au fost adăugate cu succes!",
  updateDataSuccess: "Datele au fost actualizate cu succes!",
  chooseStatusColor: "Alegeți o culoare pentru status.",

  /** LEAD TEMPLATES & CONTACT MANAGEMENT */
  leadTemplates: "Șabloane Oferte",
  leadTemplate: "Șablon Ofertă",
  createLeadTemplate: "Creează Șablon Ofertă",
  editLeadTemplate: "Editează Șablon Ofertă",
  deleteLeadTemplate: "Șterge Șablon Ofertă",
  templateCategory: "Categorie Șablon",
  emailSubject: "Subiect Email",
  whatsappMessage: "Mesaj WhatsApp",
  targetAudience: "Public Țintă",
  activeTemplate: "Șablon Activ",
  inactiveTemplate: "Șablon Inactiv",

  // Template Categories
  promotional: "Promoțional",
  seasonal: "Sezonier",
  productLaunch: "Lansare Produs",
  retention: "Retenție",
  general: "General",

  // Contact Notifications
  contactNotifications: "Notificări Contact",
  clientsToContactToday: "Clienți de Contactat Astăzi",
  pendingContacts: "Contacte în Așteptare",
  completedContacts: "Contacte Finalizate",
  noContactsToday: "Nu există clienți de contactat astăzi",

  // Contact Methods
  contactMethod: "Metodă de Contact",
  preferredMethod: "Metodă Preferată",
  contactViaEmail: "Contactează prin Email",
  contactViaWhatsApp: "Contactează prin WhatsApp",
  contactViaPhone: "Contactează prin Telefon",
  sendLead: "Trimite Ofertă",
  sendLeadEmail: "Trimite Ofertă Email",
  sendLeadWhatsApp: "Trimite Ofertă WhatsApp",
  sendBulkLeads: "Trimite Oferte în Masă",

  // Send Lead Modal
  selectTemplate: "Selectează Șablon",
  selectClients: "Selectează Clienți",
  customizeMessage: "Personalizează Mesaj",
  customSubject: "Subiect Personalizat",
  customMessage: "Mesaj Personalizat",
  previewTemplate: "Previzualizează Șablon",
  sendToClient: "Trimite către Client",
  sendToClients: "Trimite către Clienți",

  // Success/Error Messages
  leadSentSuccessfully: "Oferta a fost trimisă cu succes!",
  leadsSentSuccessfully: "Ofertele au fost trimise cu succes!",
  leadSendError: "Eroare la trimiterea ofertei!",
  templateNotSelected: "Vă rugăm să selectați un șablon!",
  noClientsSelected: "Vă rugăm să selectați cel puțin un client!",
  clientHasNoEmail: "Clientul nu are adresă de email!",
  clientHasNoPhone: "Clientul nu are număr de telefon!",
  clientNoEmailConsent: "Clientul nu a acordat consimțământ pentru email!",

  // Template Fields Help
  availableTags: "Etichete Disponibile",
  clientNameTag: "{clientName} - Numele clientului",
  companyNameTag: "{companyName} - Numele companiei",

  // Contact History
  contactHistory: "Istoric Contact",
  lastContacted: "Ultima Contactare",
  contactSuccessful: "Contact Reușit",
  contactFailed: "Contact Eșuat",
  methodUsed: "Metodă Folosită",

  // Dashboard
  todaysContactSummary: "Sumar Contacte Astăzi",
  totalClientsToContact: "Total Clienți de Contactat",
  contactedClients: "Clienți Contactați",
  remainingClients: "Clienți Rămași",

  // Filters
  filterByCategory: "Filtrează după Categorie",
  filterByMethod: "Filtrează după Metodă",
  showActiveOnly: "Arată doar Active",
  showInactiveOnly: "Arată doar Inactive",

  // Reports and Analytics
  reportsAndAnalytics: "Rapoarte și Analiză",
  analytics: "Analiză",
  generateReport: "Generează Raport",
  exportReport: "Exportă Raport",
  downloadReport: "Descarcă Raport",

  // Report Types
  salesReports: "Rapoarte Vânzări",
  marketingReports: "Rapoarte Marketing",
  supportReports: "Rapoarte Suport",

  // Sales Metrics
  revenueOverTime: "Venituri în Timp",
  revenueTrends: "Tendințe Venituri",
  totalRevenue: "Venituri Totale",
  averageOrderValue: "Valoare Medie Comandă",
  ordersByStatus: "Comenzi după Status",
  topProducts: "Produse Top",
  topClients: "Clienți Top",
  salesSummary: "Sumar Vânzări",

  // Marketing Metrics
  leadConversion: "Conversie Lead-uri",
  conversionRate: "Rată de Conversie",
  campaignPerformance: "Performanță Campanii",
  clientSegmentation: "Segmentare Clienți",
  agentPerformance: "Performanță Agenți",
  totalLeads: "Lead-uri Totale",
  finishedLeads: "Lead-uri Finalizate",
  activeLeads: "Lead-uri Active",
  contactsMade: "Contacte Realizate",
  emailsSent: "Email-uri Trimise",
  whatsAppSent: "WhatsApp Trimise",
  successRate: "Rată de Succes",

  // Support Metrics
  tasksOverview: "Prezentare Generală Sarcini",
  ticketsOverview: "Prezentare Generală Tichete",
  tasksByStatus: "Sarcini după Status",
  tasksByPriority: "Sarcini după Prioritate",
  ticketsByType: "Tichete după Tip",
  ticketsByStatus: "Tichete după Status",
  responseTimes: "Timpuri de Răspuns",
  averageResponseTime: "Timp Mediu de Răspuns",
  agentWorkload: "Sarcină de Lucru Agenți",
  completionRate: "Rată de Finalizare",
  openTasks: "Sarcini Deschise",
  overdueTasks: "Sarcini Întârziate",

  // Chart Labels
  period: "Perioadă",
  count: "Număr",
  percentage: "Procent",
  trend: "Tendință",
  comparison: "Comparație",

  // Date Ranges
  dateRange: "Interval de Date",
  last7Days: "Ultimele 7 Zile",
  last30Days: "Ultimele 30 Zile",
  last90Days: "Ultimele 90 Zile",
  thisMonth: "Luna Aceasta",
  lastMonth: "Luna Trecută",
  thisYear: "Anul Acesta",
  customRange: "Interval Personalizat",

  // Export Formats
  exportFormat: "Format Export",
  selectExportFormat: "Selectează Format Export",
  exportToCSV: "Exportă în CSV",
  exportToExcel: "Exportă în Excel",
  exportToPDF: "Exportă în PDF",
  downloadExcel: "Descarcă Excel",
  downloadPDF: "Descarcă PDF",
  generatingReport: "Se generează raportul...",
  csv: "CSV",
  excel: "Excel",
  pdf: "PDF",

  // KPIs
  kpi: "Indicator Cheie de Performanță",
  kpis: "Indicatori Cheie",
  totalOrders: "Comenzi Totale",
  totalContacts: "Contacte Totale",
  totalTasks: "Sarcini Totale",
  completedTasks: "Sarcini Completate",
  pendingTasks: "Sarcini în Așteptare",

  // Messages
  noDataAvailable: "Nu există date disponibile",
  loadingReport: "Se încarcă raportul...",
  reportGeneratedSuccessfully: "Raport generat cu succes",
  errorGeneratingReport: "Eroare la generarea raportului",
  selectDateRange: "Selectează interval de date",

  // Additional
  viewDetails: "Vezi Detalii",
  refresh: "Reîmprospătează",
  apply: "Aplică",
  groupBy: "Grupează după",

  // Support Tickets
  supportTicket: "Tichet Suport",
  newTicket: "Tichet Nou",
  createTicket: "Crează Tichet",
  ticketNumber: "Număr Tichet",
  ticketTitle: "Titlu Tichet",
  ticketDescription: "Descriere Tichet",
  ticketStatus: "Status Tichet",
  ticketPriority: "Prioritate Tichet",
  ticketType: "Tip Tichet",
  assignedTo: "Asignat către",
  assignUsers: "Asignează Utilizatori",
  ticketHistory: "Istoric Tichet",
  addComment: "Adaugă Comentariu",
  comment: "Comentariu",
  comments: "Comentarii",
  resolution: "Rezoluție",
  ticketTags: "Etichete Tichet",
  createdBy: "Creat de",
  createdAt: "Creat la",
  updatedAt: "Actualizat la",
  resolvedAt: "Rezolvat la",
  closedAt: "Închis la",
  updateStatus: "Actualizează Status",
  updatePriority: "Actualizează Prioritate",
  updateType: "Actualizează Tip",
  viewHistory: "Vezi Istoric",
  by: "de",

  // Ticket Statuses
  statusAll: "Toate",
  statusNew: "Nou",
  statusOngoing: "În Curs",
  statusResolved: "Rezolvat",
  statusClosed: "Închis",

  // Ticket Priorities
  priorityLow: "Scăzută",
  priorityMedium: "Medie",
  priorityHigh: "Ridicată",
  priorityUrgent: "Urgentă",

  // Ticket Types
  typeBug: "Bug",
  typeFeatureRequest: "Cerere Funcționalitate",
  typeSupport: "Suport",
  typeQuestion: "Întrebare",
  typeOther: "Altele",

  // Ticket Actions
  actionCreated: "Creat",
  actionStatusChanged: "Status Schimbat",
  actionAssigned: "Asignat",
  actionCommented: "Comentat",
  actionUpdated: "Actualizat",
  actionResolved: "Rezolvat",
  actionClosed: "Închis",

  // Messages
  ticketCreatedSuccess: "Tichet creat cu succes",
  ticketUpdatedSuccess: "Tichet actualizat cu succes",
  ticketDeletedSuccess: "Tichet șters cu succes",
  usersAssignedSuccess: "Utilizatori asignați cu succes",
  statusUpdatedSuccess: "Status actualizat cu succes",
  commentAddedSuccess: "Comentariu adăugat cu succes",
  ticketNotFound: "Tichet negăsit",
  selectUsers: "Selectează Utilizatori",
  selectStatus: "Selectează Status",
  noTicketsFound: "Nu s-au găsit tichete",
  filterTickets: "Filtrează Tichete",

  // Ticket History, Status and Type
  NEW: "Nou",
  ONGOING: "În Curs",
  RESOLVED: "Rezolvat",
  CLOSED: "Închis",

  LOW: "Scăzut",
  MEDIUM: "Medie",
  HIGH: "Ridicat",
  URGENT: "Urgent",

  BUG: "Bug",
  FEATURE_REQUEST: "Cerere Funcționalitate",
  SUPPORT: "Suport",
  QUESTION: "Întrebare",
  OTHER: "Altele",

  // Custom Errors
  errorGettingUsers: "Eroare la preluarea utilizatorilor",
  erorrGettingTickets: "Eroare la preluarea tichetelor",
  errorGettingClients: "Eroare la preluarea clientilor",

  // Delete Ticket
  dangerZone: "Zonă Periculoasă",
  dangerZoneEn: "Danger Zone",
  deleteTicket: "Șterge Tichet",
  deleteTicketEn: "Delete Ticket",
  deleteTicketWarning:
    "Ștergerea unui tichet este permanentă și nu poate fi anulată.",
  deleteTicketWarningEn: "Deleting a ticket is permanent and cannot be undone.",
  confirmDeleteTicket: "Confirmă Ștergerea Tichetului",
  confirmDeleteTicketEn: "Confirm Delete Ticket",
  deleteTicketConfirmation: "Sunteți sigur că doriți să ștergeți acest tichet?",
  deleteTicketConfirmationEn: "Are you sure you want to delete this ticket?",
  deleteWarningPermanent:
    "Atenție: Această acțiune este permanentă și va șterge toate datele asociate tichetului.",
  deleteWarningPermanentEn:
    "Warning: This action is permanent and will delete all data associated with the ticket.",
  deleting: "Se șterge...",
  deletingEn: "Deleting...",

  // Ticket Preview Page
  ticketPreview: "Previzualizare Tichet",
  ticketPreviewEn: "Ticket Preview",
  loadingTicket: "Se încarcă tichetul...",
  loadingTicketEn: "Loading ticket...",
  invalidOrExpiredToken: "Token invalid sau expirat",
  invalidOrExpiredTokenEn: "Invalid or expired token",
  unauthorizedAccess: "Acces neautorizat",
  unauthorizedAccessEn: "Unauthorized access",
  ticketLinkExpired: "Link-ul pentru acest tichet a expirat sau este invalid.",
  ticketLinkExpiredEn: "The link to this ticket has expired or is invalid.",
  contactSupport: "Vă rugăm să contactați echipa de suport pentru un link nou.",
  contactSupportEn: "Please contact the support team for a new link.",
  notAuthorized: "Nu sunteți autorizat să vizualizați acest tichet.",
  notAuthorizedEn: "You are not authorized to view this ticket.",
  ticketDetails: "Detalii Tichet",
  ticketDetailsEn: "Ticket Details",
  ticketInformation: "Informații Tichet",
  ticketInformationEn: "Ticket Information",
};
